export default "__VITE_PUBLIC_ASSET__9d641b74__"